module.exports = __webpack_public_path__ + "img/password.60c9e558.svg";